export function ComingSoon() {
  return (
    <div className="flex flex-col items-center justify-center w-full space-y-4">
      <video
        autoPlay
        className="w-18 h-18 md:w-24 md:h-24 object-contain"
        loop
        muted
        onCanPlay={(e) => {
          e.currentTarget.playbackRate = 2;
        }}
        playsInline
        src="/bear_alpha_smooth.webm"
      />
      <h1
        className="text-4xl font-bold tracking-tight sm:text-5xl"
        style={{ fontFamily: "var(--font-display)" }}
      >
        Coming soon!
      </h1>
    </div>
  );
}
